/* global angular _*/

import './style.less';

import { licenseStatus } from '@prolaera/library';
import templateCheckboxWidget from './template.checkbox.widget.html';
import templateCheckboxIbox from './template.checkbox.ibox.html';
import templateDropDown from './template.checkbox.dropDown.html';
import { get, keyBy, intersection } from 'lodash';
import moment from 'moment';

export default function($log, $sce, $q, $uibModal, $state, $stateParams, ProfileClass, ApiClass, RegulatorClass) {
  'ngInject';

  const vm = this;

  vm.$onChanges = activate;

  const { company_id } = ProfileClass.profileComplete.profile;

  // Clear false id's from filter.use;
  function clearUse(obj) {
    const keys = Object.keys(get(obj, 'use', {}));

    if (!keys || !keys.length) {
      return;
    }

    keys.forEach(key => {
      if (!obj.use[key]) {
        delete obj.use[key];
      }
    });

    if (obj.dict) {
      obj.names = Object.keys(obj.use).map(key => (obj.dict[key] || {}).name);
    }
  }

  // Update filters on page load
  function setFilters(collection, arr, obj, params) {
    []
      .concat(params)
      .filter(id => obj[id])
      .forEach(id => {
        collection.use[id] = true;
        collection.showLimit = arr.length;
      });
  }

  // Filter for Department
  function loadDepartments() {
    let items = false;
    if (vm.departmentsArr && vm.departmentsDict) {
      items = { arr: vm.departmentsArr, obj: vm.departmentsDict };
    } else {
      items = ApiClass.companiesIdGet({ manage: true, id: company_id }, null, {
        queryParams: { departments: true }
      }).then(({ data: { departments } }) => {
        return { arr: departments, obj: keyBy(departments, 'id') };
      });
    }

    return $q
      .resolve(items)
      .then(({ arr, obj }) => {
        vm.departments = {
          dict: obj,
          group: arr,
          names: [],
          id: 'id',
          edit: 'app.admin.settings.departments',
          key: 'department',
          name: 'Departments',
          showLimit: angular.copy(vm.showLimit),
          use: {}
        };
        if ($stateParams.department) {
          setFilters(vm.departments, arr, obj, $stateParams.department);
        }
        return vm.departments;
      })
      .catch(error => {
        $log.error('Department Filter', error);
        throw error;
      });
  }

  // Filter for Employee Level
  function loadLevels() {
    let items = false;

    if (vm.levelsArr && vm.levelsDict) {
      items = { arr: vm.levelsArr, obj: vm.levelsDict };
    } else {
      items = ApiClass.companiesIdGet({ manage: true, id: company_id }, null, {
        queryParams: { levels: true }
      }).then(({ data: { levels } }) => {
        return { arr: levels, obj: keyBy(levels, 'level_id') };
      });
    }

    return $q
      .resolve(items)
      .then(({ arr, obj }) => {
        vm.levels = {
          dict: obj,
          group: arr,
          id: 'level_id',
          edit: 'app.admin.settings.levels',
          names: [],
          key: 'level',
          name: 'Levels',
          showLimit: angular.copy(vm.showLimit),
          use: {}
        };

        if ($stateParams.level) {
          setFilters(vm.levels, arr, obj, $stateParams.level);
        }

        return vm.levels;
      })
      .catch(error => {
        $log.error('Level Filter', error);

        throw error;
      });
  }

  // Filter for Office Locations
  function loadLocations() {
    let items = false;
    if (vm.locationsArr && vm.locationsDict) {
      items = { arr: vm.locationsArr, obj: vm.locationsDict };
    } else {
      items = ApiClass.companiesIdGet({ manage: true, id: company_id }, null, {
        queryParams: { locations: true }
      }).then(({ data: { locations } }) => {
        return { arr: locations, obj: keyBy(locations, 'level_id') };
      });
    }

    return $q
      .resolve(items)
      .then(({ arr, obj }) => {
        vm.locations = {
          dict: obj,
          group: arr,
          id: 'location_id',
          key: 'locations',
          edit: 'app.admin.settings.locations',
          name: 'Locations',
          names: [],
          showLimit: angular.copy(vm.showLimit),
          use: {}
        };
        if ($stateParams.locations) {
          setFilters(vm.locations, arr, obj, $stateParams.locations);
        }
        return vm.locations;
      })
      .catch(error => {
        $log.error('Location Filter', error);
        throw error;
      });
  }

  // Filter for Practice Area
  function loadPracticeAreas() {
    let items = false;
    if (vm.practicesArr && vm.practicesDict) {
      items = { arr: vm.practicesArr, obj: vm.practicesDict };
    } else {
      items = ApiClass.companiesIdGet({ manage: true, id: company_id }, null, {
        queryParams: { practices: true }
      }).then(({ data: { practices } }) => {
        return { arr: practices, obj: keyBy(practices, 'level_id') };
      });
    }

    return $q
      .resolve(items)
      .then(({ arr, obj }) => {
        vm.practices = {
          dict: obj,
          group: arr,
          id: 'practice_id',
          key: 'practices',
          edit: 'app.admin.settings.practiceAreas',
          name: 'Practice Areas',
          names: [],
          showLimit: angular.copy(vm.showLimit),
          use: {}
        };
        if ($stateParams.practices) {
          setFilters(vm.practices, arr, obj, $stateParams.practices);
        }
        return vm.practices;
      })
      .catch(error => {
        $log.error('Level Filter', error);
        throw error;
      });
  }

  // Filter for Certifications
  function loadCertifications() {
    let certifications = false;
    if (vm.certificationsArr) certifications = vm.certificationsArr;
    else {
      certifications = ApiClass.companiesIdTypeGet({ id: company_id, type: 'certifications', manage: false }).then(
        ({ data: { items } }) => items
      );
    }

    return $q
      .resolve(certifications)
      .then(arr => {
        const dict = keyBy(arr, 'id');
        vm.certifications = {
          dict,
          group: arr,
          id: 'id',
          key: 'certifications',
          name: 'Certifications',
          names: [],
          showLimit: angular.copy(vm.showLimit),
          use: {}
        };
        if ($stateParams.certifications) setFilters(vm.certifications, arr, dict, $stateParams.certifications);
        return vm.certifications;
      })
      .catch(error => {
        $log.error('Level Filter', error);
        throw error;
      });
  }

  // Filter for type of license
  function loadRegulators() {
    const qArr = [];
    if (vm.compliance && vm.regulatorsArr && vm.regulatorsDict) {
      qArr.push(vm.compliance);
      qArr.push({ arr: vm.regulatorsArr, obj: vm.regulatorsDict });
    } else {
      qArr.push(
        ApiClass.scan(
          ApiClass.usersLicensesGet,
          {},
          {},
          {
            queryParams: {
              'filter:latest': true,
              manage: true,
              'scan:limit': 4000
            }
          }
        ).then(({ items }) => ({
          arr: items
        }))
      );
      qArr.push(RegulatorClass.loadRegulators());
    }

    return $q
      .all(qArr)
      .then(([{ arr }, regulators]) => {
        const filteredRegulators = _.uniq(_.map(arr, 'reg_id')).map(reg_id => regulators.obj[reg_id]);
        return (vm.regulators = {
          group: filteredRegulators,
          id: 'reg_id',
          key: 'regulators',
          name: 'License',
          showLimit: angular.copy(vm.showLimit),
          use: {}
        });
      })
      .catch(error => {
        $log.error('Regulator Filter', error);
        throw error;
      });
  }

  // Filter for status of license
  function loadStatus() {
    return (vm.status = {
      group: licenseStatus,
      id: 'name',
      key: 'status',
      name: 'License Status',
      showLimit: angular.copy(vm.showLimit),
      use: {}
    });
  }

  // Determine which filters to load;
  function loadFilters(type) {
    const content = {
      compliance: [loadDepartments, loadLevels, loadRegulators, loadStatus, loadLocations],
      profiles: [loadDepartments, loadLevels, loadLocations, loadPracticeAreas]
    }[type];

    if (!content) return;

    const filters = content.map(filter => filter());
    return $q.all(filters);
  }

  function updateSearchParams() {
    const queryProps = [
      ['level', 'levels'], // Filter by User Level
      'certifications', // Filter by User Certifications
      ['department', 'departments'], // Filter by User Department
      'hire_date',
      'practices', // Filter by User Practice Area
      'locations', // Filter by User Location
      'regulators', // Filter by User License
      'status' // Filter by User License Status
    ];

    vm.queryParams = {};

    queryProps.forEach(keyParam => {
      const [stateKey, vmKey] = Array.isArray(keyParam) ? keyParam : [keyParam, keyParam];

      if ($stateParams[stateKey] && vm[vmKey]) {
        vm[vmKey].use = $stateParams[stateKey];
      }

      if (vm[vmKey] && Object.keys(vm[vmKey].use).length) {
        if (!vm.queryParams[stateKey]) {
          vm.queryParams[stateKey] = {};
        }

        vm.queryParams[stateKey] = vm[vmKey].use;
      }
    });

    vm.filters = {
      first: vm.first,
      last: vm.last,
      email: vm.email,
      departments: vm.departments && vm.departments.use ? Object.keys(vm.departments.use) : [],
      levels: vm.levels && vm.levels.use ? Object.keys(vm.levels.use) : [],
      locations: vm.locations && vm.locations.use ? Object.keys(vm.locations.use) : [],
      practiceAreas: vm.practices && vm.practices.use ? Object.keys(vm.practices.use) : [],
      regulators: vm.regulators && vm.regulators.use ? Object.keys(vm.regulators.use) : [],
      tags: vm.tags || []
    };
  }

  vm.submitSearch = (reloadSearch = false) => {
    const search = {
      ...vm.queryParams,
      archived: !!vm.archived,
      first: vm.first || undefined,
      last: vm.last || undefined,
      rangeStart: vm.rangeStart ? `${moment(vm.rangeStart).valueOf()}` : undefined,
      rangeEnd: vm.rangeEnd ? `${moment(vm.rangeEnd).valueOf()}` : undefined,
      email: (vm.email || '').toLowerCase(),
      page: 1,
      tags: vm.tags || []
    };

    Object.keys(key => {
      if (typeof search[key] === 'number' || search[key]) return;

      delete search[key];
    });

    if (!reloadSearch && typeof vm.setSearch() === 'function') {
      vm.setSearch()(search);
    } else {
      $state.go('.', search, { notify: true, reload: true });
    }
  };

  // filter users based on what is selected in use;
  vm.filterUsers = (reloadSearch = true) => {
    if (vm.levels) clearUse(vm.levels);
    if (vm.departments) clearUse(vm.departments);
    if (vm.practices) clearUse(vm.practices);
    if (vm.locations) clearUse(vm.locations);
    if (vm.regulators) clearUse(vm.regulators);
    if (vm.certifications) clearUse(vm.certifications);
    if (vm.status) clearUse(vm.status);

    if (vm.updateSearchParams || vm.search) updateSearchParams();
    if (vm.updateSearchParams && reloadSearch) vm.submitSearch();
    if (vm.search) return; // exit early if search only;

    vm.filtered = vm.ngModel.filter(({ profile_uid, reg_id, status }) => {
      if (!vm.profileDict[profile_uid]) {
        return false;
      }

      const { certifications, department, hire_date, level, locations, practices, tags } = vm.profileDict[profile_uid];

      const hireDateMin = vm.hireDateMin && moment(vm.hireDateMin).valueOf();
      const hireDateMax = vm.hireDateMax && moment(vm.hireDateMax).valueOf();
      const hireDate = hire_date && moment(hire_date).valueOf();

      if (hireDateMin || hireDateMax) {
        if (!hireDate) {
          return false;
        }

        if (hireDateMin && hireDateMin >= hireDate) {
          return false;
        }

        if (hireDateMax && hireDateMax <= hireDate) {
          return false;
        }
      }

      // Filter by User Level
      if (vm.levels && Object.keys(vm.levels.use).length) {
        if (!level || !vm.levels.use[level]) return false;
      }

      // Filter by User Certifications
      if (vm.certifications && Object.keys(vm.certifications.use).length) {
        if (!certifications) return false;
        let certificationCheck = false;
        certifications.forEach(({ id }) => {
          if (vm.certifications.use[id]) certificationCheck = true;
        });
        if (!certificationCheck) return false;
      }
      // Filter by User Department
      if (vm.departments && Object.keys(vm.departments.use).length) {
        if (!department) {
          return false;
        }

        let departmentCheck = false;
        department.forEach(id => {
          if (vm.departments.use[id]) {
            departmentCheck = true;
          }
        });
        if (!departmentCheck) {
          return false;
        }
      }
      // Filter by User Practice Area
      if (vm.practices && Object.keys(vm.practices.use).length) {
        if (!practices) return false;
        let practiceCheck = false;
        practices.forEach(id => {
          if (vm.practices.use[id]) return (practiceCheck = true);
        });
        if (!practiceCheck) return false;
      }
      // Filter by User Location
      if (vm.locations && Object.keys(vm.locations.use).length) {
        if (!locations) return false;
        let locationCheck = false;
        locations.forEach(id => {
          if (vm.locations.use[id]) return (locationCheck = true);
        });
        if (!locationCheck) return false;
      }

      // Filter by User Tags
      if (vm.tags && vm.tags.length) {
        if (!tags) return false;

        return !!intersection(tags || [], vm.tags || []).length;
      }

      // Filter by User License
      if (vm.regulators && Object.keys(vm.regulators.use).length) {
        if (!reg_id || !vm.regulators.use[reg_id]) return false;
      }

      // Filter by User Status
      if (vm.status && Object.keys(vm.status.use).length) {
        if (!status || !vm.status.use[status]) return false;
      }

      return true;
    });
  };

  // Clear All Filters and Show Mores
  vm.clear = () => {
    vm.activeFilters.forEach(filter => {
      for (const key in filter.use) {
        delete filter.use[key];
      }

      filter.showLimit = angular.copy(vm.showLimit);
    });

    vm.archived = undefined;
    vm.first = undefined;
    vm.last = undefined;
    vm.email = undefined;
    vm.rangeStart = undefined;
    vm.rangeEnd = undefined;
    vm.tags = undefined;

    vm.filterUsers();
    vm.submitSearch();
  };

  function activate() {
    $log.debug('Users Search Component Activated');

    if (!vm.ngModel) return;

    const { archived, first, last, email, rangeEnd, rangeStart, tags } = $stateParams;
    vm.archived = archived;
    vm.first = first;
    vm.last = last;
    vm.rangeStart = rangeStart ? new Date(Number(rangeStart)) : undefined;
    vm.rangeEnd = rangeEnd ? new Date(Number(rangeEnd)) : undefined;
    vm.tags = tags;

    vm.email = (email || '').toLowerCase();

    vm.showLimit = 3;
    vm.template = $sce.trustAsHtml(
      { dropDown: templateDropDown, ibox: templateCheckboxIbox, widget: templateCheckboxWidget }[vm.style || 'ibox']
    );

    const profiles = vm.search
      ? { obj: {} }
      : vm.dict
        ? { obj: vm.dict }
        : ApiClass.scan(
            ApiClass.usersGet,
            {},
            {},
            {
              queryParams: {
                manage: true,
                'include:type': 'basic',
                'scan:limit': 2000
              }
            }
          ).then(({ items }) => ({
            obj: _.keyBy(items, 'profile_uid')
          }));

    $q.resolve(profiles)
      .then(({ obj }) => {
        vm.profileDict = obj;

        return loadFilters(vm.contentType);
      })
      .then(filters => {
        vm.filterUsers(false);
        vm.activeFilters = filters;
        vm.loaded = true;
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/usersSearch/controller.js